// NOTE We need to wrap localStorage in a try/catch because it can throw in
// embedded contexts (e.g. in an iframe) due to cross-origin restrictions.

const localStorageSessionKey = "interfacesSessionId" as const;

let _sessionId: string | undefined;

export function setProjectSessionId(sessionId: string) {
  if (typeof window !== "undefined") {
    _sessionId = sessionId;

    try {
      window.localStorage.setItem(localStorageSessionKey, sessionId);
    } catch {}
  }
}

export function getProjectSessionId() {
  if (typeof window !== "undefined") {
    try {
      return _sessionId || window.localStorage.getItem(localStorageSessionKey);
    } catch {
      return _sessionId;
    }
  }
}
